import React from "react";

const LoaderData = ({ message = "Loading data..." }) => {
  return (
    <div id="preloader" className="loader-data">
      <div className="preloader-container">
        <div className="logo-container">
          <img
            src={require("../assets/images/logo-gsmi.svg").default || require("../assets/images/logo-gsmi.svg")}
            alt="GSMI Logo"
            className="logo"
          />
        </div>
        <div className="loading-text">
          {/* <span className="loading-message">{message}</span> */}
          <div className="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoaderData;
